import {UserModel} from 'app/modules/auth'
import clsx from 'clsx'
import {isStaff, isTeacher} from 'common/HelperFunctions'
import Avatar from 'common/components/Avatar'
import {revertToOriginalUser} from 'common/helpers'
import {FC} from 'react'
import {useIntl} from 'react-intl'
import {shallowEqual, useSelector} from 'react-redux'
import {Link} from 'react-router'
import {RootState, UserReducer} from 'setup'

import {Languages} from './Languages'

const HeaderUserMenu: FC = () => {
  const userReducer: UserReducer = useSelector<RootState>(
    ({userReducer}) => userReducer,
    shallowEqual
  ) as UserReducer

  const user: UserModel = userReducer.user as UserModel
  const userType: string = userReducer.userType as string

  const impersonation: any = userReducer.impersonation

  const intl = useIntl()

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3'>
        {impersonation && <div className='p-2'>{intl.$t({id: 'USER.LOGGED_IN_AS'})}</div>}
        <div className='menu-content d-flex align-items-center px-3'>
          <Avatar
            src={user.profilePicture}
            size='50'
            label={user.name}
            color='primary'
            className={clsx('me-5', {'border border-primary': !!impersonation})}
          />

          <div className='d-flex flex-column text-break'>
            <div className='fw-bolder d-flex align-items-center fs-5'>
              {user.name}
              <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                {userType}
              </span>
            </div>
            <span className='fw-bold text-muted text-hover-primary fs-7 text-break cursor-pointer'>
              {user.email}
            </span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      {impersonation && (
        <>
          <div className='menu-item px-3'>
            <div className='d-flex align-items-center justify-content-between p-2'>
              <span>{intl.$t({id: 'USER.ORIGINAL_USER'})}</span>

              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary'
                onClick={revertToOriginalUser}
              >
                <i className='fa fa-undo'></i>
              </button>
            </div>
            <div className='menu-content d-flex align-items-center px-3'>
              <Avatar
                src={impersonation.user.profilePicture}
                size='50'
                label={impersonation.user.name}
                color='primary'
                className='me-5'
              />

              <div className='d-flex flex-column text-break'>
                <div className='fw-bolder d-flex align-items-center fs-5'>
                  {impersonation.user.name}
                  <span className='badge badge-light-success fw-bolder fs-8 px-2 py-1 ms-2'>
                    {impersonation.userType}
                  </span>
                </div>
                <span className='fw-bold text-muted text-hover-primary fs-7 text-break cursor-pointer'>
                  {impersonation.user.email}
                </span>
              </div>
            </div>
          </div>

          <div className='separator my-2'></div>
        </>
      )}

      <div className='menu-item px-5'>
        <Link to={'/profile'} className='menu-link px-5'>
          <span className='menu-text'>{intl.formatMessage({id: 'MENU.MY_PROFILE'})}</span>
        </Link>
      </div>
      {(isStaff() || isTeacher()) && (
        <div className='menu-item px-5'>
          <Link to={'/institute/user/mcstudent'} className='menu-link px-5'>
            <span className='menu-text'>
              {intl.formatMessage({id: 'MENU.MY_ASSIGNED_STUDENTS'})}
            </span>
          </Link>
        </div>
      )}

      <div className='separator my-2'></div>

      <Languages />

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link className='menu-link px-5' to='/logout'>
          {intl.formatMessage({id: 'MENU.SIGN_OUT'})}
        </Link>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
